module.exports = __webpack_public_path__ + "static/media/jean-paul-gaultier.df8d5259.png";